import { render, staticRenderFns } from "./testContent.vue?vue&type=template&id=bdd203b6&scoped=true&"
import script from "./testContent.vue?vue&type=script&lang=js&"
export * from "./testContent.vue?vue&type=script&lang=js&"
import style0 from "./testContent.vue?vue&type=style&index=0&id=bdd203b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd203b6",
  null
  
)

export default component.exports